import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAPI } from "../../service/http-service";
import { CommonEndpoint } from "../../service/endpointConfig/CommonEndpoint";

let initialState: any = {
  regionResponse: {},
};

// Get Region API call
export const RegionService = createAsyncThunk(
  "master/region",
  async (region: any) => {
    try {
      return await getAPI(CommonEndpoint.region);
    } catch (err) {
      return err;
    }
  }
);

const regionSlice = createSlice({
  name: "region",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      RegionService.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.status = action.payload?.status;
        state.error = "";
        state.data = action.payload?.data?.data;
      }
    );
    builder.addCase(RegionService.rejected, (state, action) => {
      state.loading = false;
      state.status = -1;
      state.error = action.error.message || "Something went wrong";
      state.data = {};
    });
  },
});

const regionReducer = regionSlice.reducer;
export default regionReducer;
